/* ============================================================================
 * ФОРМАТИРОВАНИЕ ВЕЛИЧИН И ВРЕМЕНИ (для консоли ИВО)
 * ========================================================================= */

/** Высота в метрах — ключевой формат ТЗ (высоты в МЕТРАХ) */
export function fmtAlt(m: number | undefined | null): string {
  if (m === undefined || m === null || !Number.isFinite(m)) return '—'
  return `${m.toFixed(0)} м`
}

/** Скорость: м/с и км/ч для оператора */
export function fmtSpeed(ms: number | undefined | null): string {
  if (ms === undefined || ms === null || !Number.isFinite(ms)) return '—'
  return `${ms.toFixed(1)} м/с · ${(ms * 3.6).toFixed(0)} км/ч`
}

/** Расстояние: метры до километров */
export function fmtDistance(m: number | undefined | null): string {
  if (m === undefined || m === null || !Number.isFinite(m)) return '—'
  return m < 1000 ? `${m.toFixed(0)} м` : `${(m / 1000).toFixed(2)} км`
}

/** Азимут в градусах истинного севера с румбом */
const COMPASS_16 = ['С', 'ССВ', 'СВ', 'ВСВ', 'В', 'ВЮВ', 'ЮВ', 'ЮЮВ',
                   'Ю', 'ЮЮЗ', 'ЮЗ', 'ЗЮЗ', 'З', 'ЗСЗ', 'СЗ', 'ССЗ']

export function fmtBearing(deg: number | undefined | null): string {
  if (deg === undefined || deg === null || !Number.isFinite(deg)) return '—'
  const norm = ((deg % 360) + 360) % 360
  const idx = Math.round(norm / 22.5) % 16
  return `${norm.toFixed(0).padStart(3, '0')}° ${COMPASS_16[idx]}`
}

/** Масса, кг */
export function fmtMass(kg: number | undefined | null): string {
  if (kg === undefined || kg === null || !Number.isFinite(kg)) return '—'
  return `${kg.toFixed(1)} кг`
}

/** Проценты (заряд батареи) */
export function fmtPct(v: number | undefined | null): string {
  if (v === undefined || v === null || !Number.isFinite(v)) return '—'
  return `${v.toFixed(0)}%`
}

/** Время HH:MM:SS по локальному времени */
export function fmtClock(iso: string | null | undefined): string {
  if (!iso) return '—'
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return '—'
  return d.toLocaleTimeString('ru-RU', { hour12: false })
}

/** Дата-время ДД.ММ.ГГГГ ЧЧ:ММ:СС */
export function fmtDateTime(iso: string | null | undefined): string {
  if (!iso) return '—'
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return '—'
  return d.toLocaleString('ru-RU', {
    day: '2-digit', month: '2-digit', year: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false,
  })
}

/** «N мин назад» — для индикатора свежести данных */
export function fmtAge(iso: string | null | undefined): string {
  if (!iso) return 'нет данных'
  const d = new Date(iso).getTime()
  if (Number.isNaN(d)) return 'нет данных'
  const sec = Math.max(0, Math.round((Date.now() - d) / 1000))
  if (sec < 5) return 'только что'
  if (sec < 60) return `${sec} с назад`
  const min = Math.round(sec / 60)
  if (min < 60) return `${min} мин назад`
  return `${Math.round(min / 60)} ч назад`
}

/** Человекочитаемый статус деградации бэкенда */
export function fmtDegradedReason(r: string | undefined | null): string {
  switch (r) {
    case 'timeout':
      return 'Превышен таймаут — источник не отвечает'
    case 'network':
      return 'Сеть недоступна'
    case 'backend':
      return 'Ошибка бэкенда'
    default:
      return 'Нет данных'
  }
}
